/**
 * Messages browsers give a `fetch` that obtained no response at all (offline, DNS failure,
 * dropped connection, CORS rejection, request aborted by a page unload): Chrome, Safari, Firefox.
 */
const TRANSPORT_FAILURE_MESSAGES = [
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
];

interface MarkedError extends Error {
  isNetworkError?: boolean;
}

/**
 * Whether `error` is a request that never got a response — an expected connectivity failure, not
 * an application defect. True for what Ajax#request marked, and for a bare `TypeError` from a
 * `fetch` made elsewhere.
 */
export function isNetworkError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  if ((error as MarkedError).isNetworkError) return true;

  return error instanceof TypeError && TRANSPORT_FAILURE_MESSAGES.includes(error.message);
}

/**
 * Sentry `beforeSend`: drops connectivity failures, keeps every other event untouched.
 */
export function dropNetworkErrors<TEvent>(
  event: TEvent,
  hint?: { originalException?: unknown },
): TEvent | null {
  return isNetworkError(hint?.originalException) ? null : event;
}
